import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden px-4 sm:px-6 lg:px-8" data-id="element-106">
      <div className="max-w-7xl mx-auto text-center" data-id="element-107">
        <FadeIn data-id="element-108">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-lavender/20 text-darkText text-sm font-medium mb-8" data-id="element-109">
            <Sparkles className="w-4 h-4 text-gold" data-id="element-110" />
            <span data-id="element-111">El sistema probado para madres emprendedoras</span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-112">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-darkText mb-6 leading-tight max-w-4xl mx-auto" data-id="element-113">
            InstaPrint AI: Tu Imperio de Arte Digital con Inteligencia
            Artificial
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-114">
          <p className="text-lg md:text-xl text-lightText mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-115">
            Crea y vende colecciones de arte infantil de alta demanda en
            minutos, sin saber diseñar y trabajando desde casa.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-116">
          <div className="relative max-w-4xl mx-auto mb-12" data-id="element-117">
            <div className="absolute inset-0 bg-lavender/30 rounded-3xl blur-3xl transform -rotate-3 scale-105 -z-10" data-id="element-118"></div>
            <img src="https://cdn.magicpatterns.com/uploads/nW5Q8UJphuJvDFCXNBvkq8/InstaPrint_AI_imagen.png" alt="InstaPrint AI en diferentes dispositivos mostrando arte infantil" className="w-full h-auto rounded-2xl shadow-soft object-cover border-4 border-white" data-id="element-119" />
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-120">
          <div className="flex flex-col items-center gap-4" data-id="element-121">
            <a href="#pricing-cta" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-peach hover:bg-peachHover transition-colors rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 duration-300 w-full sm:w-auto" data-id="element-122">
              ¡SÍ, QUIERO EMPEZAR MI TIENDA DE IA AHORA!
            </a>
            <p className="text-sm text-lightText flex items-center gap-2" data-id="element-123">
              <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-124"></span>
              Acceso inmediato tras la compra
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}